import { socialExport } from '@mi-front/api-clients';
import { SelectElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';

export function YoutubePrivacyStatusField() {
  const { $t } = useIntl();
  return (
    <SelectElement
      name="privacyStatus"
      label={$t({
        id: 'youtube.privacyStatus.label',
        defaultMessage: 'Estado de privacidad',
      })}
      options={[
        {
          id: socialExport.YoutubeSettingsDtoPrivacyStatusEnum.private,
          label: $t({
            id: 'youtube.privacyStatus.private',
            defaultMessage: 'Privado',
          }),
        },
        {
          id: socialExport.YoutubeSettingsDtoPrivacyStatusEnum.public,
          label: $t({
            id: 'youtube.privacyStatus.public',
            defaultMessage: 'Público',
          }),
        },
        {
          id: socialExport.YoutubeSettingsDtoPrivacyStatusEnum.unlisted,
          label: $t({
            id: 'youtube.privacyStatus.unlisted',
            defaultMessage: 'No listado',
          }),
        },
      ]}
      fullWidth
      required
    />
  );
}
